module.exports = __webpack_public_path__ + "img/banner-1.048c17be.jpg";